import { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Formik } from 'formik';
import { toast } from 'react-toastify';
import * as Yup from 'yup';

import Icon from '../../common/Icon';
import TextInput from '../../common/Inputs/TextInput';
import { getDonatationToken, submitDonatationForm } from '../../../js/api/donate-foundations';

export default function DonateForm({ closeModal }) {
  const { t } = useTranslation(['DonatePage', 'ContactPage']);
  const [iframeData, setIframeData] = useState(null);

  const DonateFormSchema = Yup.object().shape({
    first_name: Yup.string().required(t('firstNameError')),
    last_name: Yup.string().required(t('lastNameError')),
    email: Yup.string().email(t('invalidEmail')).required(t('emailRequired')),
    amount: Yup.number()
      .typeError(t('amountMustBeNumber'))
      .positive(t('amountMustBePositive'))
      .required(t('donationAmountRequired')),
    phone: Yup.string()
      .matches(/^\d+$/, t('phoneNumberRequired'))
      .required(t('phoneNumberRequired')),

    address: Yup.string(),
    city: Yup.string(),
    state: Yup.string(),
    postal_code: Yup.string(),
    country: Yup.string()
  });

  const onConfirm = async (data) => {
    await getDonatationToken({
      ...data
    })
      .then((response) => {
        setIframeData(response);
      })
      .catch((error) => {
        closeModal();
        toast.error(t('genericError'));
        throw error;
      });
  };

  const onSubmitForm = async (values) => {
    await submitDonatationForm(values)
      .then((response) => {
        onConfirm({ amount: values.amount, manara_id: response?.data?.id });
      })
      .catch((error) => {
        closeModal();
        toast.error(t('genericError'));
        throw error;
      });
  };

  return (
    <div
      className={`donate-modal__container donate-modal__form ${iframeData && 'iframeContainer'}`}>
      <div className="donate-modal__header">
        <h2></h2>
        <button
          type="button"
          className="button close-button"
          title="close popup"
          onClick={() => closeModal()}>
          <Icon name="close" />
        </button>
      </div>
      {iframeData?.payment_link ? (
        <iframe
          id="iframe-payment"
          srcDoc={`
              <html xmlns="http://www.w3.org/1999/xhtml">
              <head>
                <meta http-equiv="X-UA-Compatible" content="IE=edge">
                <meta charset="utf-8">
                <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0">
                <script src="scripts/jquery.min.js"></script>
                <script src="scripts/bootstrap.min.js"></script>
                <script type="text/javascript">
                  $(function () {
                    $("#btnContinue").click(function () {
                      $("#redirectToken").val($("#inputtoken").val());
                      });
                    });
                </script>
              </head>
              <body>
                <input type="text" id="inputtoken" value="" />
                <br />
                <form method="post" action="https://accept.authorize.net/payment/payment" id="formAuthorizeNetTestPage" name="formAuthorizeNetTestPage">
                  <input type="hidden" id="redirectToken" name="token" value="${iframeData?.token}" />
                  Redirect-Continue to Authorize.net to Payment Page
                  <button id="btnContinue" onclick="">Continue to next page</button>
                </form>
              </body>
              </html>
            `}
        />
      ) : (
        <Fragment>
          <Formik
            initialValues={{
              amount: '',
              first_name: '',
              last_name: '',
              email: '',
              phone: '',
              address: '',
              city: '',
              state: '',
              postal_code: '',
              country: ''
            }}
            validationSchema={DonateFormSchema}
            onSubmit={async (values, { errors, resetForm }) => {
              await onSubmitForm(values);
              if (!errors) resetForm();
            }}>
            {({ errors, touched }) => (
              <Form className="donate-modal__amount__form">
                <div className="donate-modal__name_inputs">
                  <TextInput
                    label={t('firstNameLabel')}
                    name="first_name"
                    type="text"
                    id="firstName"
                    required
                    icon={null}
                    placeholder={t('firstNamePlaceholder')}
                    hasError={touched.first_name && errors.first_name}
                    theme="dark">
                    {errors.first_name && touched.first_name ? (
                      <span className="error-msg">{errors.first_name}</span>
                    ) : null}
                  </TextInput>

                  <TextInput
                    label={t('lastNameLabel')}
                    name="last_name"
                    type="text"
                    id="last_name"
                    required
                    icon={null}
                    placeholder={t('lastNamePlaceholder')}
                    hasError={touched.last_name && errors.last_name}
                    theme="dark">
                    {errors.last_name && touched.last_name ? (
                      <span className="error-msg">{errors.last_name}</span>
                    ) : null}
                  </TextInput>
                </div>

                <TextInput
                  label={t('emailLabel')}
                  name="email"
                  type="email"
                  id="email"
                  required
                  icon={null}
                  placeholder={t('emailPlaceholder')}
                  hasError={touched.email && errors.email}
                  theme="dark">
                  {errors.email && touched.email ? (
                    <span className="error-msg">{errors.email}</span>
                  ) : null}
                </TextInput>

                <TextInput
                  label={t('donationAmount')}
                  name="amount"
                  type="text"
                  id="amount"
                  icon={null}
                  required
                  placeholder="$10,000"
                  hasError={touched.amount && errors.amount}
                  iconClassName="amount__icon"
                  theme="dark">
                  {errors.amount && touched.amount ? (
                    <span className="error-msg">{errors.amount}</span>
                  ) : null}
                </TextInput>

                <TextInput
                  label={t('phoneNumberLabel')}
                  name="phone"
                  type="text"
                  id="phoneNumber"
                  required
                  icon={null}
                  placeholder={t('phoneNumberPlaceholder')}
                  hasError={touched.phone && errors.phone}
                  theme="dark">
                  {errors.phone && touched.phone ? (
                    <span className="error-msg">{errors.phone}</span>
                  ) : null}
                </TextInput>

                <div className="donate-modal__name_inputs">
                  <TextInput
                    label={t('addressLabel')}
                    name="address"
                    type="text"
                    id="address"
                    icon={null}
                    placeholder={t('addressPlaceholder')}
                    hasError={touched.address && errors.address}
                    theme="dark">
                    {errors.address && touched.address ? (
                      <span className="error-msg">{errors.address}</span>
                    ) : null}
                  </TextInput>

                  <TextInput
                    label={t('cityLabel')}
                    name="city"
                    type="text"
                    id="city"
                    icon={null}
                    placeholder={t('cityPlaceholder')}
                    hasError={touched.city && errors.city}
                    theme="dark">
                    {errors.city && touched.city ? (
                      <span className="error-msg">{errors.city}</span>
                    ) : null}
                  </TextInput>
                </div>

                <div className="donate-modal__name_inputs">
                  <TextInput
                    label={t('stateLabel')}
                    name="state"
                    type="text"
                    id="state"
                    icon={null}
                    placeholder={t('statePlaceholder')}
                    hasError={touched.state && errors.state}
                    theme="dark">
                    {errors.state && touched.state ? (
                      <span className="error-msg">{errors.state}</span>
                    ) : null}
                  </TextInput>

                  <TextInput
                    label={t('zipCodeLabel')}
                    name="postal_code"
                    type="text"
                    id="postal_code"
                    icon={null}
                    placeholder={t('zipCodePlaceholder')}
                    hasError={touched.postal_code && errors.postal_code}
                    theme="dark">
                    {errors.postal_code && touched.postal_code ? (
                      <span className="error-msg">{errors.postal_code}</span>
                    ) : null}
                  </TextInput>
                </div>

                <TextInput
                  label={t('countryLabel')}
                  name="country"
                  type="text"
                  id="country"
                  icon={null}
                  placeholder={t('countryPlaceholder')}
                  hasError={touched.country && errors.country}
                  theme="dark">
                  {errors.country && touched.country ? (
                    <span className="error-msg">{errors.country}</span>
                  ) : null}
                </TextInput>

                <button type="submit" className="button submit-button">
                  {t('donateConfirm')}
                </button>
              </Form>
            )}
          </Formik>
        </Fragment>
      )}
    </div>
  );
}
